export default [
  {
    path: "tracingEnterprise",
    name: "溯源企业列表",
    component: () =>
      import("../views/traceabilitySystem/tracingEnterprise/index.vue"),
  },
  {
    path: "traceableProduct",
    name: "溯源产品列表",
    component: () =>
      import("../views/traceabilitySystem/traceableProduct/index.vue"),
  },
  {
    path: "traceableCode",
    name: "溯源码管理",
    component: () =>
      import("../views/traceabilitySystem/traceableCode/index.vue"),
  },
  {
    path: "userFeedback",
    name: "用户反馈管理",
    component: () =>
      import("../views/traceabilitySystem/userFeedback/index.vue"),
  },
];
